import { Icons, styled } from '@arpeggi/ui'

const Root = styled('div', {
  padding: '16px 0',
  minHeight: '100px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  background: 'transparent',
  transition: 'all 100ms ease',
  cursor: 'pointer',
  userSelect: 'none',
  borderRadius: '8px',
  '&:hover': {
    background: '$blackA050'
  },
  variants: {
    disabled: {
      true: {
        pointerEvents: 'none'
      }
    }
  }
})

const Icon = styled(Icons.Studio, {
  width: '32px',
  height: '32px',
  strokeWidth: '1.4px',
  color: '$black',
  marginBottom: '16px'
})

const Title = styled('div', {
  fontSize: '$16',
  fontWeight: 500,
  fontFamily: '$DMMono',
  marginBottom: '10px'
})

const Action = styled('div', {
  fontSize: '$16',
  fontWeight: 500,
  fontFamily: '$DMMono',
  color: '$indigo0700'
})

export const RecentEmpty = { Root, Title, Icon, Action }
